export default "assets/images/background-0f364906.jpg";